import { Images } from '../../../utils/imageConstants';
import { FaPlus } from 'react-icons/fa';

export interface TeamTabEmptyStateProps {
  topActionLabel?: string;
  topActionClassName?: string;
  onTopAction?: () => void;
  title: string;
  subtitle?: string;
  primaryButtonLabel: string;
  onPrimaryAction: () => void;
}

function TeamTabEmptyState({
  topActionLabel,
  topActionClassName,
  onTopAction,
  title,
  subtitle,
  primaryButtonLabel,
  onPrimaryAction,
}: TeamTabEmptyStateProps) {
  const showTopAction = topActionLabel && topActionClassName && onTopAction;
  return (
    <div className="myteam-tab-empty">
      {showTopAction && (
      <button
        type="button"
        className={topActionClassName}
        onClick={onTopAction}
      >
        <span style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <FaPlus />
        </span>
        {topActionLabel}
      </button>
      )}
      <div className="myteam-empty-content">
        <img src={Images.my_leagues_no} alt="" className="myteam-empty-illu myteam-empty-illu-circle" />
        <p className="myteam-empty-title">
          {title}
          {subtitle && <><br />{subtitle}</>}
        </p>
        <button
          type="button"
          className="myteam-empty-cta-primary"
          onClick={onPrimaryAction}
        >
          {primaryButtonLabel}
        </button>
      </div>
    </div>
  );
}

export default TeamTabEmptyState;
